import React from 'react'
import *  as Icons from 'react-bootstrap-icons'
import { Spinner } from 'react-bootstrap'
import useInterests from '../../../hooks/use-interests'
import { get, find } from 'lodash'

const InterestIcon = ({
    userInterest = {},
    size = 25
}) => {
    const { isBusy, interests } = useInterests()
    const interest = find(interests, { id: userInterest })
    const Icon = Icons[get(interest, 'icon') || 'EmojiSmile']

    if (isBusy) {
        return (
            <Spinner animation="grow" variant="primary" />
        )
    }

    return (
        <Icon size={size} />
    )
}

export default InterestIcon